import React from 'react';
import { createRoot } from 'react-dom/client';

/**
 * Importing SCSS before the application is essential to generate css in the correct order.
 */
import '../styles/main.scss';
import App from './navigation/application';

const root = createRoot(document.getElementById('app'));
root.render(<App />);
